<template>
  <div style="padding-left: 3%; padding-right: 3%">
    <v-select
      :items="listSpaceObjectGroups"
      :item-text="'name'"
      :item-value="'id'"
      :label="'Space object group'"
      v-model="selectedGroup"
    >
      <template v-slot:item="{ item }">
        <v-container
          class="align-center"
          v-on:click="updateListSatellite(item)"
        >
          <span>{{ item.name }}</span>
        </v-container>
      </template>
    </v-select>

    <v-data-table
      :headers="headerTableGroup"
      :items="listSatellites"
      :height="250"
      @click:row="sendSatelliteNoradId"
      item-key="noradId"
      show
      hide-default-footer
      style="width: 100%"
      dense
    >
    </v-data-table>
    <ScreeningCatalogueAnalysisGroupDialogue
      v-on:update-space-object-group="updateListSpaceObjectGroup"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import defense from '../../mixins/defense.js'
import ScreeningCatalogueAnalysisGroupDialogue from './ScreeningCatalogueAnalysisGroupDialogue.vue'
import spaceObjectGroupUtils from '../../mixins/spaceObjectGroupUtils.js'
export default {
  name: 'ScreeningCatalogueAnalysisGroupCard',
  props: {},
  mixins: [defense, spaceObjectGroupUtils],
  data() {
    return {
      listSpaceObjectGroups: [],
      listSatellites: [],
      selectedGroup: null,
      headerTableGroup: [{ text: 'Norad ID', value: 'noradId' }]
    }
  },
  components: { ScreeningCatalogueAnalysisGroupDialogue },

  watch: {
    listSpaceObjectGroups() {
      return this.listSpaceObjectGroups
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser'
    })
  },
  mounted() {
    this.updateListSpaceObjectGroup()
  },
  methods: {
    async deleteSpaceObjectGroupInList(idSpaceObjectGroup) {
      await this.deleteSpaceObjectGroup(idSpaceObjectGroup)
      this.updateListSpaceObjectGroup()
      if (idSpaceObjectGroup === this.selectedGroup) {
        this.listSatellites = []
      }
    },
    updateListSatellite(spaceObjectGroup) {
      this.listSatellites = []
      if (spaceObjectGroup) {
        for (
          let i = 0;
          i < spaceObjectGroup.spaceObjectIdentifiers.length;
          i++
        ) {
          this.listSatellites.push({
            noradId: spaceObjectGroup.spaceObjectIdentifiers[i]
          })
        }
      }
    },
    async updateOneSpaceObjectGroup(item) {
      this.updateListSpaceObjectGroup()
      let spaceObjectgroup = await this.getSpaceObjectGroup(item.id)
      this.updateListSatellite(spaceObjectgroup)
      this.selectedGroup = item.id
    },

    sendSatelliteNoradId(item) {
      this.$emit('satellite-norad-id-method', item.noradId)
    },

    async updateListSpaceObjectGroup() {
      this.listSpaceObjectGroups = await this.getAllSpaceObjectGroup()
    }
  }
}
</script>
